import { take, call, put, fork } from 'redux-saga/effects';
import {
  failGetData,
  successGetData,
  getData,
  putData,
} from '../actions/inquiry';
import superFetch from '../modules/superFetch';
import { push } from 'connected-react-router';
import { toast } from 'react-toastify';

// [redux-saga] ...非同期処理を取り扱う仕組み
// 関数を作成したらモジュールの最後尾 saga()にてFork する事。
// while(true) で待機状態を作る。
// yield take(`${actionName}`) に定義したアクション名を受け取ると発火する。
// アクション名は ../actions/{module_name}.js にて定義する。
// 発火させるには component にて this.props.dispatch(actionName());
// disaptchしたものは 戻り値.payloadで取り出せる。
// action関数の引数は sagaに渡される前に reducer/{module_name}.jsにて処理され
// stateの状態変更を行っている

export function* handleGetData() {
  while (true) {
    yield take(`${getData}`);
    const jwt = localStorage.getItem('jwt');
    const { payload, err } = yield call(superFetch, {
      url: '/api/inquiry/',
      type: 'GET',
      custom: {
        headers: {
          authorization: `Bearer ${jwt}`,
        },
      },
    });

    if (payload && !err) {
      yield put(successGetData({ data: payload }));
      continue;
    }

    if (!payload && err) {
      yield put(failGetData(String(err)));
      continue;
    }
  }
}
export function* handlePutData() {
  while (true) {
    const actions = yield take(`${putData}`);
    const jwt = localStorage.getItem('jwt');
    const { payload, err } = yield call(superFetch, {
      url: '/api/inquiry/put',
      type: 'POST',
      data: actions.payload,
      custom: {
        headers: {
          authorization: `Bearer ${jwt}`,
        },
      },
    });

    if (payload && !err) {
      yield put(
        successGetData({
          comment: '',
          inquiryType: '',
          contentsType: '',
          returnId: undefined,
          parentId: undefined,
        })
      );
      yield put(push('/mypage/inquiry'));
      yield toast.success('問い合わせを行いました。');
      continue;
    }

    if (!payload && err) {
      yield put(failGetData(String(err)));
      continue;
    }
  }
}
//作った関数をまとめて form 関数名 saga() の変更は必要無し。
export default function* saga() {
  yield fork(handleGetData);
  yield fork(handlePutData);
}



// WEBPACK FOOTER //
// ./src/sagas/inquiry.js